
import commonApi from "@/apis/common.api";
import { $_DKD } from "@/confs/common.const.js";
import {$_TYPE} from "../confs/common.const";

export default {
    state: {
        covidGuNmMappingMap: {
            'val19': '도봉구',
            'val20': '노원구',
            'val21': '중랑구',
            'val22': '강동구',
            'val23': '성북구',
            'val24': '동대문구',
            'val25': '광진구',
            'val26': '송파구',
            'val27': '강남구',
            'val28': '서초구',
            'val29': '관악구',
            'val30': '동작구',
            'val31': '금천구',
            'val32': '구로구',
            'val33': '양천구',
            'val34': '영등포구',
            'val35': '강서구',
            'val36': '마포구',
            'val37': '서대문구',
            'val38': '은평구',
            'val39': '종로구',
            'val40': '중구',
            'val41': '성동구',
            'val42': '용산구',
            'val43': '강북구',
            'val44': '기타',
        },
        covidSeoul: {},
        covidSeoulList: [],
        covidDaySeoulList: [],
        covidGangnamList: [],
        covidNationalList: [],
        covidNationalSumList: [],
        covidIsolationList: [],
        covidCheckupLocList: [],
    },
    getters: {
        getCovidGuNmMappingMap(state) {
            return state.covidGuNmMappingMap;
        },
        getCovidSeoul(state) {
            return state.covidSeoul;
        },
        getCovidSeoulList(state) {
            return state.covidSeoulList;
        },
        getCovidDaySeoulList(state) {
            return state.covidDaySeoulList;
        },
        getCovidGangnamList(state) {
            return state.covidGangnamList;
        },
        getCovidNationalList(state) {
            return state.covidNationalList;
        },
        getCovidNationalSumList(state) {
            return state.covidNationalSumList;
        },
        getCovidIsolationList(state) {
            return state.covidIsolationList;
        },
        getCovidCheckupLocList(state) {
            return state.covidCheckupLocList;
        },
    },
    mutations: {
        COVID_SEOUL(state, covidSeoul) {
            state.covidSeoul = covidSeoul;
        },
        COVID_SEOUL_LIST(state, covidSeoulList) {
            state.covidSeoulList = covidSeoulList;
        },
        COVID_DAY_SEOUL_LIST(state, covidDaySeoulList) {
            state.covidDaySeoulList = covidDaySeoulList;
        },
        COVID_GANGNAM_LIST(state, covidGangnamList) {
            state.covidGangnamList = covidGangnamList;
        },
        COVID_NATIONAL_LIST(state, covidNationalList) {
            state.covidNationalList = covidNationalList;
        },
        COVID_NATIONAL_SUM_LIST(state, covidNationalSumList) {
            state.covidNationalSumList = covidNationalSumList;
        },
        COVID_ISOLATION_LIST(state, covidIsolationList) {
            state.covidIsolationList = covidIsolationList;
        },
        COVID_CHECKUP_LOC_LIST(state, covidCheckupLocList) {
            state.covidCheckupLocList = covidCheckupLocList;
        },
    },
    actions : {
        FETCH_COVID_SEOUL({commit}) {
            let q = 'orderBy=basdtVal::desc&searchLimit=15';
            return commonApi.fetchRepoDataList($_DKD.COVID_SEOUL_CONFIRM, q)
                .then(res=>{
                    commit('COVID_SEOUL', res.data.data[0]);
                    commit('COVID_SEOUL_LIST', res.data.data);
                });
        },
        FETCH_COVID_DAY_SEOUL_LIST({commit}) {
            let q = 'orderBy=basdtVal::desc&searchLimit=15';
            return commonApi.fetchRepoDataList($_DKD.COVID_DAY_SEOUL_CONFIRM, q)
                .then(res=>{
                    commit('COVID_DAY_SEOUL_LIST', res.data.data);
                });
        },
        FETCH_COVID_GANGNAM_LIST({commit}) {
            let today = new Date();
            let searchDay = new Date(today - (3600000 * 24 * 30));
            let searchFromDate = searchDay.format('yyyyMMdd');
            let q = 'searchFromDate=' + searchFromDate + '&orderBy=basdtVal::desc';

            return commonApi.fetchRepoDataList($_DKD.COVID_STATUS_GANGNAM, q)
                .then(res=>{
                    commit('COVID_GANGNAM_LIST', res.data.data);
                });
        },
        FETCH_COVID_NATIONAL_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.COVID_STATUS_NATIONAL)
                .then(res=>{
                    commit('COVID_NATIONAL_LIST', res.data.data);
                });
        },
        FETCH_COVID_NATIONAL_SUM_LIST({commit}) {
            let today = new Date();
            let searchDay = new Date(today - (3600000 * 24 * 7));
            let searchFromDate = searchDay.format('yyyyMMdd');
            let q = 'searchFromDate=' + searchFromDate + '&where=val2::' + encodeURIComponent('합계') + '&orderBy=basdtVal::desc';

            return commonApi.fetchRepoDataList($_DKD.COVID_STATUS_NATIONAL, q)
                .then(res=>{
                    commit('COVID_NATIONAL_SUM_LIST', res.data.data);
                });
        },
        FETCH_COVID_ISOLATION_LIST({commit}) {
            let today = new Date();
            let searchDay = new Date(today - (3600000 * 24 * 15));
            let searchFromDate = searchDay.format('yyyyMMdd');
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                searchFromDate = '20220401';
            }
            let q = 'searchFromDate=' + searchFromDate + '&orderBy=basdtVal::desc';

            let isolationList = [];
            const isolationMap = {};
            return commonApi.fetchRepoDataList($_DKD.COVID_ISOLATION, q)
                .then(res=>{
                    // console.log(res.data.data);
                    res.data.data.forEach(d => {
                        if(typeof isolationMap[d.basdtVal] === $_TYPE.UNDEF){
                            isolationMap[d.basdtVal] = {
                                basdtVal: d.basdtVal,
                                dayCnt: 0,
                                allCnt: 0,
                            };
                            isolationList.push(isolationMap[d.basdtVal]);
                        }
                        if(!isNaN(d.val8)){
                            isolationMap[d.basdtVal].dayCnt += Number(d.val8);
                        }
                        if(!isNaN(d.val9)) {
                            isolationMap[d.basdtVal].dayCnt += Number(d.val9);
                        }
                        if(!isNaN(d.val4)){
                            isolationMap[d.basdtVal].allCnt += Number(d.val4);
                        }
                        if(!isNaN(d.val7)) {
                            isolationMap[d.basdtVal].allCnt += Number(d.val7);
                        }
                    });
                    isolationList.sort((cur, pre) => {
                        return cur.basdtVal > pre.basdtVal ? -1 : cur.basdtVal < pre.basdtVal ? 1 : 0;
                    })
                    commit('COVID_ISOLATION_LIST', isolationList);
                });
        },
        FETCH_COVID_CHECKUP_LOC_LIST({commit}) {
            let q = 'where=val1::' + encodeURIComponent('합계') + '&searchLimit=20&orderBy=basdtVal::desc';
            return commonApi.fetchRepoDataList($_DKD.COVID_CHECKUP_LOC, q)
                .then(res=>{
                    commit('COVID_CHECKUP_LOC_LIST', res.data.data);
                });
        },
    }
};
